module.exports = __webpack_public_path__ + "img/img-commission-sec-10.png";